import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShareBorrowerDialogComponent } from './share-borrower-dialog/share-borrower-dialog.component';
import { ShareBorrowerSmartComponent } from './share-borrower-smart/share-borrower-smart.component';
import { ShareBorrowerComponent } from './share-borrower/share-borrower.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { UserAvatarModule } from 'app/user-avatar/user-avatar.module';
import { MatButtonModule } from '@angular/material/button';



@NgModule({
  declarations: [
    ShareBorrowerDialogComponent,
    ShareBorrowerSmartComponent,
    ShareBorrowerComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    ReactiveFormsModule,
    ScrollingModule,
    UserAvatarModule,
    MatButtonModule,
  ],
  exports: [
    ShareBorrowerDialogComponent
  ]
})
export class ShareBorrowerModule { }
